module.exports = __webpack_public_path__ + "img/logo_lumajang.bfca89fe.png";